/**
 * Local-date helpers. NEVER use ``new Date().toISOString().slice(0,10)`` for
 * UI dates — it converts to UTC and shifts the day for any non-UTC user.
 * Use {@link ymd} for "YYYY-MM-DD in the user's local timezone" and
 * {@link parseYmd} when reading such strings back.
 */
export function ymd(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}

export function parseYmd(s: string): Date {
  // s = "YYYY-MM-DD" → local midnight
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
}

/** "21 мая, Пн" */
export function fmtWeekdayDate(d: Date): string {
  const wd = ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"][d.getDay()];
  return `${wd} ${d.toLocaleDateString("ru-RU", { day: "2-digit", month: "2-digit", year: "numeric" })}`;
}

/** ISO datetime → "21.05 14:30" in the user's local TZ */
export function fmtSlot(iso: string): string {
  return new Date(iso).toLocaleString("ru-RU", {
    day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit",
  });
}

/**
 * A real-UTC instant (server clock: norm changes, systemd, file times) as station
 * wall-clock ISO — Kabul, UTC+4:30 — the convention every data timestamp in the app
 * already follows, so it can go through the usual fmtDT / fmtD / fmtT.
 */
export function toStation(iso: string): string {
  return new Date(Date.parse(iso) + 270 * 60_000).toISOString();
}
